import React from "react";
import PropTypes from "prop-types";
import ButtonLoader from "../Loaders/ButtonLoader";
import i18next from "i18next";

// Basic button component
const Button = ({
    label,
    variant,
    type,
    size = "LG",
    onClick,
    icon,
    customStyle,
    loading,
    href,
    newTab,
    disabled = false,
}) => {
    let buttonStyle = `btn btn__${variant} btn__${size} ${
        icon && "btn__with-icon"
    } ${customStyle}`;

    if (loading) {
        return (
            <button className={buttonStyle + " btn__loading"} disabled>
                <ButtonLoader />
            </button>
        );
    }

    if (href) {
        return (
            <a
                href={href}
                className={buttonStyle}
                target={newTab ? "_blank" : null}
                rel={newTab ? "noopener noreferrer" : null}>
                {icon && icon}
                {label}
            </a>
        );
    }

    return (
        <button
            type={type}
            className={buttonStyle}
            onClick={onClick}
            disabled={disabled}>
            {icon && icon}
            {label}
        </button>
    );
};

// Common buttons
export const ForwardButton = (props) => {
    // eslint-disable-next-line no-unused-vars
    const { label, customStyle, icon, ...rest } = props;
    return (
        <Button
            label={label ? label : i18next.t("cart.continue")}
            icon={<i className="fas fa-chevron-right fa-md"></i>}
            customStyle={"btn__forward " + customStyle}
            {...rest}
        />
    );
};

const buttonProps = {
    label: PropTypes.string,
    variant: PropTypes.oneOf([
        "primary",
        "secondary",
        "tertiary",
        "reversed",
        "category",
        "danger",
    ]),
    type: PropTypes.string,
    size: PropTypes.oneOf(["XL", "LG", "SM", "XS"]),
    disabled: PropTypes.bool,
    onClick: PropTypes.func,
    icon: PropTypes.oneOfType([PropTypes.element, PropTypes.bool]),
    customStyle: PropTypes.string,
    loading: PropTypes.bool,
    href: PropTypes.string,
    newTab: PropTypes.bool,
};

const defaultBtnProps = {
    variant: "primary",
    type: "button",
    icon: false,
    disabled: false,
    customStyle: "",
    label: "Save",
    newTab: false,
};

Button.propTypes = buttonProps;
ForwardButton.propTypes = buttonProps;
Button.defaultProps = defaultBtnProps;
ForwardButton.defaultProps = defaultBtnProps;

export default Button;
